<template>
    <div class="cartsummary">
        <div class="cart-summary">
            <div class="border-round">
                <h2 class="ui text big-lg medium-sm small semibold black p-3 mb-0 text-center">{{$t('Summary')}}</h2>
                <hr class="gray-7 mt-0">
                <div class="d-flex align-items-center p-3">
                    <span class="ui text medium-md tiny-sm tiny light color gray-7 align-items-center d-flex">{{$t('Subtotal')}}</span> 
                    <span class="ui text medium-md tiny-sm tiny light color gray-7 align-items-center d-flex ml-auto">
                        <strong class="color black">{{sumPrice}} {{currency}}</strong></span></div>
                <hr class="gray-7 mt-0">
                <div class="d-flex align-items-center p-3">
                    <span class="ui text medium-md tiny-sm tiny light color gray-7 align-items-center d-flex">{{$t('ShippingCharge')}}</span> 
                    <span class="ui text medium-md tiny-sm tiny light color gray-7 align-items-center d-flex ml-auto">
                        <strong class="color black">{{deliveryFee}} {{currency}}</strong></span></div>
                <!-- <hr class="gray-7 mt-0"> -->
                <!-- <div class="d-flex align-items-center p-3"><span class="ui text medium-md tiny-sm tiny light color gray-7 align-items-center d-flex">ภาษีมูลค่าเพิ่ม 7%</span> <span class="ui text medium-md tiny-sm tiny light color gray-7 align-items-center d-flex ml-auto"><strong class="color black mr-2"></strong>บาท</span></div> -->
                <hr class="gray-7 mt-0">
                <div class="d-flex align-items-center p-3">
                    <span class="ui text medium-md tiny-sm tiny light color theme align-items-center d-flex">{{$t('Total')}}</span> 
                    <span class="ui text medium-md tiny-sm tiny light color theme align-items-center d-flex ml-auto">
                        <strong class="color theme">{{total}}</strong>
                        {{ "&nbsp; " + currency}}
                        </span>
                </div>
            </div>
        </div>
        <div v-if="$parent.step > 2 && $parent.deliveryTypes == 'carrier'" class="cart-address mt-3">
            <div class="border-round">
                <h2 class="ui text big-lg medium-sm small semibold black p-3 mb-0">{{$t('ShippingAddress')}}</h2>
                <hr class="gray-7 m-0">
                <div class="p-3">
                    <p class="ui text medium-md tiny-sm tiny light">{{$parent.shippingName}}</p>
                    <p class="ui text medium-md tiny-sm tiny light mb-1">{{$parent.boxAddress.name}}</p>
                    <p class="ui text medium-md tiny-sm tiny light mb-1">{{$parent.boxAddress.text}}</p>
                    <p class="ui text medium-md tiny-sm tiny light mb-1">{{$t('Mobile')}} {{$parent.boxAddress.phone}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cartsummary',
    components: {},
    props: {
        sumPrice : 0,
        deliveryFee: 0,
        total: 0,
        currency: String
    },
    data () {
        return {}
    },
    computed: {},
    
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>

</style>